import AbsComponent from "../../components/AbsComponent";
import { attribute } from './TemplMagicdollAttribute';
import { summary } from './TemplMagicdollSummary';

export default class TemplMagicdoll extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);
    }

    loadData(_id, _option = 0, _callback){
        this.buffcardGrowthLevel = _option;

        this.loading = jQuery('.swiper-wrapper .nc-community-loader');
        this.loading.addClass('is-show').show();
        $(this.el).hide();

        // @see https://sb-api-lineagew.plaync.com/game/docs/index.html#game-magicDoll
        const { config } = this.store.getState(); 
        axios( {
            method: 'GET',
            url: `${config.apiDomain}/game/magic-dolls/${_id}`,
            withCredentials: (window.isLoginFlag === 'true'),
            params: { 
                locale: config.locale,
                level: this.buffcardGrowthLevel || 0
            }
        })
        .then( (_res) => {
            this.render(_res.data);
            this.addEvents();
            _callback(this.name);
        })
        .catch( (error, d) => console.log(error,'load----', d) )
        .then( (d) => {
            this.loading.removeClass('is-show').hide();
        } );
    }

    render(it = {}){
        const state = this.store.getState();
        const { l10n } = state.config;

        const isSkinType = (it.buffCardType === 4); // 2: 마법인형, 4: 마법인형 스킨

        this.templ = `
        <div class="gameinfo-detail__list" data-type="magicdoll">
            <div class="gameinfo-detail__left">
                ${summary(l10n, it, {
                    isSkinType,
                    defaultThumb: state.defaultThumb,
                    buffcardGrowthLevel: this.buffcardGrowthLevel,
                })}
                ${attribute(l10n, it)}
            </div>
            <div class="gameinfo-detail__right">
                <section class="collection">
                    <header>
                        <h3>${l10n['common.collection']}</h3>
                        <button class="btn-folder is-active"></button>
                    </header>
                    ${it.collections.length? `<article class="is-active">${this.collectionList(it.collections)}</article>
                    `: `<article class="is-active nodata"><p>${l10n['common.none']}</p></article>`}
                </section>
            </div>
        </div>`;

        $(this.el).show();
        $(this.el).html( this.templ );
    }

    addEvents() {
        // set level select events
        const $levelSelect = $(`${this.el} .select`);
        $levelSelect.on('click', (e) => $(`${this.el} .option`).toggle());

        $(document).on('click', e => {
            // close select options when click outside of select
            if (!$(e.target).hasClass('selectedCategory')) {
                $(this.el + ' .option').toggle(false);
            }
        });
    }

    collectionList(_it){
        return _it.map( it => {
            return `
            <div class="collection-list">
                <h4 class="collection-name">${it.name}</h4>
                <p class="collection-option${it.completed? ' collection-completed': ''}">
                    ${it.options.map( op => op.displayValue).join(', ')}
                </p>
                <ul class="collection-item">
                    ${it.cards.map( card => {
                        return `
                        <li>
                            <button class="btn-item" data-detailshow="magic-dolls_${card.id}" data-id="${card.id}" title="${card.name}">
                                <img class="thumb" src="${card.image}" onerror="this.src='${this.store.getState().defaultThumb}';">
                                ${card.acquired? `<span class="mine"></span>`: ``}
                                ${card.level > 0 ? `<span class="level">${card.level}</span>` : ``}
                            </button>
                        </li>`
                    }).join('')}
                </ul>
            </div>`;
        }).join('');
    }

} // end of class